import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Tile } from "carbon-components-react";
function ActivityItem(props) {
  const {
    activityName,
    activityStatus,
    activityColor,
    activityTypeIcon,
    activityType,
  } = props;

  return (
    <Tile className="activity-card">
      <div
        className="activity-card-container"
        style={{
          backgroundColor: activityColor.color,
        }}
      >
        <div className="activity-thumbnail-container">
          <img
            className="activity-thumbnail-image"
            src={activityColor.image}
            alt="logo"
          />
          <div
            className="activity-icon-cont"
            style={{
              backgroundColor: activityColor.color,
            }}
          >
            <img
              src={activityTypeIcon}
              alt="logo"
              style={{
                width: "24px",
                height: "24px",
                objectFit: "contain",
              }}
            />
          </div>
          <span
            className="activity-type-label"
            style={{
              backgroundColor: activityColor.color,
            }}
          >
            {activityType}
          </span>
        </div>
        <div
          className="activity-label-container"
          style={{ backgroundColor: activityColor.color }}
        >
          <span className="activity-title">{activityName}</span>
          <span className="activity-status">{activityStatus}</span>
        </div>
      </div>
    </Tile>
  );
}
const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ActivityItem);
